import React from 'react';
import styled from 'App/styled';
import { State } from 'store/types';
import ProductCarousel from '@nykaa/product-card-carousel';
import Product from 'components/ProductList/Product';
import { ListingProduct } from '@nykaa/listing-shared/type/product';
import { useSelector } from 'react-redux';
import { hidePlpWidgets } from 'helpers/filters';
import { isListingItemTipTile } from '@nykaa/listing-shared/utils/product';

interface ProductListProp {
  products: ListingProduct[];
  idx: number;
}

const Wrapper = styled.div`
  margin-left: 10px;
  margin-right: 20px;
`;
const CarouselWrapper = styled.div`
  display: flex;
  justify-content: center;
`;
const Container = styled.div`
  margin-top: 20px;
  padding: 24px 20px;
  background-color: #eaeaea;
  .carousal-card {
    width: auto;
    min-width: 280px;
    width: 280px;
  }
`;
const Header = styled.div`
  display: flex;

  margin-bottom: 20px;
  justify-content: space-between;
`;
const ViewAll = styled.a`
  display: flex;
  padding-right: 0.75rem;
  justify-content: space-between;
  align-items: center;
  text-decoration: none;
  text-transform: uppercase;
  background: transparent;
  ${({ theme }) => theme.typography.type142};
  cursor: pointer;
  border: none;
  color: ${(props) => props.theme.brandPrimary};
  .arrow {
    ${({ theme }) => theme.typography.bodyXSmall};
    margin-left: 2px;
  }
`;
const Title = styled.h2`
  text-transform: uppercase;
  ${({ theme }) => theme.typography.type200};
  color: #3f414d;
`;

const Carousel = ({ idx, products }: ProductListProp) => {
  const GetProductList = (
    <>
      {products?.map((product, index) => (
        <Product
          key={`carousal-card-${index}`}
          size="compact"
          isPro={false}
          positionInList={index}
          product={product}
          customClass="carousal-card"
        />
      ))}
    </>
  );
  return (
    <CarouselWrapper>
      <ProductCarousel
        key={idx}
        ListItem={GetProductList}
        numberOfCardToDisplay={4}
        listLength={products.length}
        cardWidth={280}
        isInfiniteEnable
      />
    </CarouselWrapper>
  );
};

function Widgets() {
  const widgetsData = useSelector(
    (state: State) => state.categoryListing.plpWidgets
  );
  const activeFilters = useSelector(
    (state: State) => state.categoryListing.activeFilters
  );
  const activeSort = activeFilters?.sort || '';
  let list = widgetsData?.data || [];
  const ids = widgetsData?.ids || [];
  const hideWidgets = hidePlpWidgets(list, ids, activeSort, activeFilters);
  if (hideWidgets) {
    return null;
  }

  return (
    <Wrapper>
      {list.map((listingProduct: any, idx: number) => {
        let products = listingProduct?.products?.filter(
          (card) => !isListingItemTipTile(card) && card.inStock
        );
        if (!products.length) {
          return null;
        }
        return (
          <Container key={idx}>
            <Header>
              <Title>{listingProduct?.categoryName}</Title>
              <ViewAll href={listingProduct?.url}>
                <span>View All</span>
                <span className="arrow">❯</span>
              </ViewAll>
            </Header>
            <Carousel
              products={products}
              idx={idx}
            />
          </Container>
        );
      })}
    </Wrapper>
  );
}

export default Widgets;
